import FormsIcon from 'assets/dualicons/forms.svg?react'
import DocumentAddIcon from 'assets/nav-icons/document-add.svg?react'
import WindowIcon from 'assets/nav-icons/window.svg?react'
import SwapIcon from 'assets/nav-icons/swap.svg?react'
import ValidationIcon from 'assets/nav-icons/validation.svg?react'
import BadgeIcon from 'assets/nav-icons/badge.svg?react'
import { NAV_TYPE_ROOT, NAV_TYPE_ITEM } from 'constants/app.constant'


const ROOT_FORMS = '/forms';


const path = (root, item) => `${root}${item}`;


export const forms = {
    id: 'forms',
    type: NAV_TYPE_ROOT,
    path: '/forms',
    title: 'Forms',
    transKey: 'Forms',
    Icon: FormsIcon,
    permissionCode: "FDFDView",
    childs: [
        {
            id: 'forms.form-builder',
            type: NAV_TYPE_ITEM,
            path: path(ROOT_FORMS, '/form-builder'),
            title: 'Form Builder',
            transKey: 'Form Builder',
            Icon: DocumentAddIcon,
            permissionCode: "FBVF",
        },
        {
            id: 'forms.master-fields',
            type: NAV_TYPE_ITEM,
            path: path(ROOT_FORMS, '/master-fields'),
            title: 'Master Fields',
            transKey: 'Master Fields',
            Icon: BadgeIcon,
            permissionCode: "FBVF",
        },
        // {
        //     id: 'forms.landing-pages',
        //     type: NAV_TYPE_ITEM,
        //     path: path(ROOT_FORMS, '/landing-pages'),
        //     title: 'Landing Pages',
        //     transKey: 'Landing Pages',
        //     Icon: WindowIcon
        // },
        // {
        //     id: 'forms.embed-codes',
        //     type: NAV_TYPE_ITEM,
        //     path: path(ROOT_FORMS, '/embed-codes'),
        //     title: 'Embed Codes',
        //     transKey: 'Embed Codes',
        //     Icon: SwapIcon
        // },
        // {
        //     id: 'forms.field-mapping',
        //     type: NAV_TYPE_ITEM,
        //     path: path(ROOT_FORMS, '/field-mapping'),
        //     title: 'Field Mapping',
        //     transKey: 'Field Mapping',
        //     Icon: ValidationIcon
        // }
    ]
}
